import { render, staticRenderFns } from "./InfoToPatient.vue?vue&type=template&id=e5d1d918"
import script from "./InfoToPatient.vue?vue&type=script&lang=js"
export * from "./InfoToPatient.vue?vue&type=script&lang=js"
import style0 from "./InfoToPatient.vue?vue&type=style&index=0&id=e5d1d918&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports